import {otto} from "@otto-ec/global-resources/nexus";
import {Aggregation} from "./aggregation";

if (!otto.ft3.promo.aggregation.isReady) {
    otto.ft3.promo.aggregation.assignNamespace({
        init: () => new Aggregation().init()
    }, {
        lock: true
    });
}